import { HorizontalFlex, VerticalFlex, Sect } from "pandora/styled";
import { useState, useEffect, useContext } from "react";
import UploadImageToS3 from "./UploadImageToS3";

export default function Organisation() {
  const [tenantName, setTenantName] = useState("");

  return (
    <VerticalFlex>
      <HorizontalFlex>
        <Sect css="font-size: 24px; font-weight: 600">
          {tenantName}
          <UploadImageToS3 />
        </Sect>
      </HorizontalFlex>
    </VerticalFlex>
  );
}
